import { useTranslation } from 'react-i18next';

const STYLES = {
  PENDING: 'bg-amber-500/20 text-amber-300',
  ACTIVE: 'bg-emerald-500/20 text-emerald-300',
  SUSPENDED: 'bg-orange-500/20 text-orange-300',
  CANCELLED: 'bg-red-500/20 text-red-300',
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const label = t(`status.tenant.${status}`, { defaultValue: status });

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${STYLES[status] || 'bg-zinc-700 text-zinc-700 dark:text-zinc-300'}`}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
